<template>
  <div class="activation">
    <div class="content">
      <el-radio-group v-model="tabPosition" size="small" @change="changeTabPosition">
        <el-radio-button label="用户活跃度">用户活跃度</el-radio-button>
        <el-radio-button label="项目运行指标">项目运行指标</el-radio-button>
      </el-radio-group>
      <div class="screenRegion">
        <span>项目编号：</span>
        <el-input v-model="prjCode" placeholder="项目编号查询" size="small" clearable style="width:230px" maxlength="50" />
        <span style="margin-left: 20px;">项目名称：</span>
        <el-input v-model="prjName" placeholder="项目名称查询" size="small" clearable style="width:230px" maxlength="100" />
        <span v-if="tabPosition=='项目运行指标'" style="margin-left: 20px;">统计时间：</span>
        <el-date-picker v-if="tabPosition=='项目运行指标'" v-model="inspectionReportDate" :picker-options="pickerOptions" type="daterange" size="small" align="right"
          start-placeholder="开始时间" range-separator="至" end-placeholder="结束时间" unlink-panels :clearable="false">
        </el-date-picker>
        <el-button size="small" style="margin-left: 20px;" plain @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button v-if="tabPosition=='项目运行指标'" size="small" style="margin-left: 20px;" plain @click="exportExcel(1)">导出excel</el-button>
      </div>
      <div class="tableStyle">
        <el-table v-if="tabPosition=='用户活跃度'" :key="tabPosition" v-loading="loading" :data="prjData" border
          element-loading-text="数据加载中" height="100%" highlight-current-row
          style="width:100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
          </template>
          <el-table-column prop="prjCode" label="项目编号" min-width="130px" show-overflow-tooltip />
          <el-table-column prop="prjName" label="项目名称" min-width="150px">
            <template #default="{ row }">
              <el-link type="primary" @click="lookPrj(row)">
                <span class="tabLinkSpan" :title="row.prjName">{{ row.prjName }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="80px" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isEnabled == 0">禁用</span>
              <span v-if="scope.row.isEnabled == 1" style="color: #0ABB87">启用</span>
            </template>
          </el-table-column>
          <el-table-column prop="prjLeaderName" label="项目总负责人" min-width="100px" align="center" />
          <el-table-column label="参与人员活跃度" min-width="120px" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="lookPrj(scope.row)">点击查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-if="tabPosition=='项目运行指标'" :key="tabPosition" :data="prjData" border
          element-loading-text="数据加载中" height="100%" highlight-current-row
          style="width:100%" row-key="prjId" @selection-change="selectionInspectionReport">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
          </template>
          <el-table-column prop="" type="selection" width="55" align="center" reserve-selection />
          <el-table-column prop="prjName" label="项目名称" min-width="100px" show-overflow-tooltip />
          <el-table-column prop="annotation" label="批注" min-width="100px" align="center" />
          <el-table-column prop="download" label="下载" min-width="100px" align="center" />
          <el-table-column prop="viewFile" label="浏览" min-width="100px" align="center" />
          <el-table-column prop="uploadFile" label="新建文件" min-width="100px" align="center" />
          <el-table-column prop="uploadVersion" label="提交版本" min-width="100px" align="center" />
          <el-table-column prop="tzFlow" label="提资" min-width="100px" align="center" />
          <el-table-column prop="checkFlow" label="校审" min-width="100px" align="center" />
          <el-table-column prop="publishFlow" label="出版" min-width="100px" align="center" />
          <el-table-column prop="allWorkTime" label="总工时" min-width="100px" align="center" />
          <el-table-column prop="cadWorkTime" label="CAD工时" min-width="100px" align="center" />
          <el-table-column prop="revitWorkTime" label="revit工时" min-width="100px" align="center" />
          <el-table-column prop="plotNum" label="发图量" min-width="100px" align="center" />
        </el-table>
      </div>
      <div class="page">
        <page :page="pagePrj" class="el-pagination" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData">
        </page>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="dialogActivation" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="beforeClose" :title="titleActivation" width="1700px">
      <el-form class="dialog-h" inline size="small">
        <el-form-item label="姓名:">
          <el-input v-model="name" clearable prefix-icon="el-icon-search" placeholder="请输入姓名" size="small" maxlength="10" />
        </el-form-item>
        <el-form-item label="统计时间:">
          <el-date-picker v-model="statisticalTime" :picker-options="pickerOptions" type="daterange" size="small" align="right"
            start-placeholder="开始时间" range-separator="至" end-placeholder="结束时间" unlink-panels :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" plain @click="resetActivation">重置</el-button>
          <el-button size="small" type="primary" @click="searchActivation">查询</el-button>
          <el-button size="small" style="margin-left: 20px;" plain @click="exportExcel(2)">导出excel</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="activationTab" v-loading="loading" :data="activationList" border element-loading-text="数据加载中" height="550px"
        highlight-current-row style="width:100%" row-key="userId" @selection-change="selectionActivation">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column type="selection" align="center" width="55" reserve-selection></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100px" show-overflow-tooltip />
        <el-table-column prop="specName" label="专业" min-width="100px" show-overflow-tooltip />
        <el-table-column prop="roleName" label="角色" min-width="100px" show-overflow-tooltip />
        <el-table-column prop="annotation" label="批注" min-width="100px" align="center" />
        <el-table-column prop="download" label="下载" min-width="100px" align="center" />
        <el-table-column prop="viewFile" label="浏览" min-width="100px" align="center" />
        <el-table-column prop="uploadFile" label="新建文件" min-width="100px" align="center" />
        <el-table-column prop="uploadVersion" label="提交版本" min-width="100px" align="center" />
        <el-table-column prop="tzFlow" label="提资" min-width="100px" align="center" />
        <el-table-column prop="checkFlow" label="校审" min-width="100px" align="center" />
        <el-table-column prop="publishFlow" label="出版" min-width="100px" align="center" />
        <el-table-column prop="allWorkTime" label="总工时" min-width="100px" align="center" />
        <el-table-column prop="cadWorkTime" label="CAD工时" min-width="100px" align="center" />
        <el-table-column prop="revitWorkTime" label="revit工时" min-width="100px" align="center" />
        <el-table-column prop="plotNum" label="发图量" min-width="100px" align="center" />
      </el-table>
      <page :page="page" style="text-align: right;" @handleSizeChange="handleSizeChangePrj" @handleCurrentChange="getActivationList">
      </page>
    </el-dialog>
    <!-- 导出excel -->
    <el-dialog v-dialogDrag :visible.sync="excelSelectVisiable" :close-on-click-modal="false"
      :close-on-press-escape="false" title="导出excel" width="700px">
      <div v-for="(item, index) in exportExcelItem" :key="index" class="openModify">
        <el-radio :key="item" v-model="exportExcelradio" :label="item">
          {{ item }}
        </el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="excelSelectCannel">取 消</el-button>
        <el-button v-preventReClick type="primary" size="small" @click="excelSelectSure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
import activationService from "@/CommonDP/service/activation-service";
import moment from "moment";
import { GetDateTime } from "@/CommonDP/utils/validate";
export default {
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tabPosition: '用户活跃度',
      inspectionReportDate: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()], // 选择项目时间
      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      prjCode: '',
      prjName: '',
      prjData: [],
      loading: false,
      pagePrj: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      inspectionReportList: [],
      dialogActivation: false,
      titleActivation: '',
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      name: '',
      activationList: [],
      statisticalTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()],
      prj: {},
      excelSelectVisiable: false, // 导出
      exportExcelItem: ["目前选中", "当前页", "全部"], // 导出excel
      exportExcelradio: "", // 选中的导出类型
      multipleSelection: [],
      exportType: 1
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    // 开始时间
    statisticalStartDate() {
      if (this.statisticalTime && this.statisticalTime.length > 0) {
        return moment(this.statisticalTime[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    statisticalEndDate() {
      if (this.statisticalTime && this.statisticalTime.length > 1) {
        return moment(this.statisticalTime[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        return "";
      }
    },
    inspectionReportStartDate() {
      if (this.inspectionReportDate && this.inspectionReportDate.length > 0) {
        return moment(this.inspectionReportDate[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    inspectionReportEndDate() {
      if (this.inspectionReportDate && this.inspectionReportDate.length > 1) {
        return moment(this.inspectionReportDate[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.getPrjList();
  },
  methods: {
    // 重置
    reset() {
      this.inspectionReportDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      this.prjCode = "";
      this.prjName = "";
      this.fetchData(1);
    },
    // 查询
    search() {
      this.fetchData(1);
    },
    changeTabPosition() {
      this.pagePrj.pageNum = 1;
      this.pagePrj.pageSize = 10;
      this.multipleSelection = [];
      this.reset();
    },

    async getPrjList() {
      this.loading = true;
      const {
        pagePrj: { pageNum, pageSize },
        enterpriseId,
        prjCode,
        prjName
      } = this;
      const params = {
        enterpriseId,
        pageNum,
        pageSize,
        prjCode,
        prjName,
        startDate: this.inspectionReportStartDate,
        endDate: this.inspectionReportEndDate
      };
      if (this.tabPosition === '用户活跃度') { delete params.startDate;delete params.endDate; }
      const res = this.tabPosition === '用户活跃度' ? await activationService.getProjectList(params) : await activationService.getInspectionReport(params);
      this.prjData = res.data;
      this.pagePrj.pageNum = res.pageIndex;
      this.pagePrj.totalCount = res.totalCount;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.pagePrj.pageSize = val;
      this.fetchData(1);
    },
    fetchData(val) {
      this.pagePrj.pageNum = val;
      this.getPrjList();
    },
    lookPrj(val) {
      this.prj = val;
      this.multipleSelection = [];
      this.dialogActivation = true;
      this.$nextTick(() => {
        this.$refs.activationTab.clearSelection();
      });
      this.titleActivation = '用户活跃度 - ' + val.prjName;
      this.name = '';
      this.statisticalTime = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.queryActivationPrjPage();
    },
    async queryActivationPrjPage() {
      const {
        page: { pageNum, pageSize }
      } = this;
      const params = {
        pageNum,
        pageSize,
        prjId: this.prj.prjId,
        name: this.name,
        startDate: this.statisticalStartDate,
        endDate: this.statisticalEndDate
      };
      const res = await activationService.getActivationPrjPage(params);
      this.activationList = res.data;
      this.page.pageNum = res.pageIndex;
      this.page.totalCount = res.totalCount;
    },
    beforeClose() {
      this.dialogActivation = false;
    },
    // 重置
    resetActivation() {
      this.name = '';
      this.statisticalTime = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      this.getActivationList(1);
    },
    // 查询
    searchActivation() {
      this.getActivationList(1);
    },
    handleSizeChangePrj(val) {
      this.page.pageSize = val;
      this.getActivationList(1);
    },
    getActivationList(val) {
      this.page.pageNum = val;
      this.queryActivationPrjPage();
    },
    exportExcel(val) {
      this.exportType = val;
      this.exportExcelradio = "目前选中";
      this.excelSelectVisiable = true;
    },
    // 导出取消
    excelSelectCannel() {
      this.excelSelectVisiable = false;
      this.exportExcelradio = "";
    },
    excelSelectSure() {
      let list = [];
      if (this.exportExcelradio === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择需要导出的数据");
          return;
        } else {
          list = this.multipleSelection;
        }
      } else if (this.exportExcelradio === "当前页") {
        const data = this.exportType === 1 ? this.prjData : this.activationList;
        if (data.length === 0) {
          this.$message.warning("暂无数据");
          return;
        } else {
          list = data;
        }
      } else {
        list = [];
      }
      if (this.exportType === 1) {
        this.gexcelSureinspectionReport(list);
      } else {
        this.excelSureActivation(list);
      }
    },
    gexcelSureinspectionReport(list) {
      const {
        pagePrj: { pageNum, pageSize },
        enterpriseId,
        prjCode,
        prjName
      } = this;
      const params = {
        enterpriseId,
        pageNum,
        pageSize,
        prjCode,
        prjName,
        startDate: this.inspectionReportStartDate,
        endDate: this.inspectionReportEndDate,
        list
      };
      activationService.InspectionReportExport(params).then((response) => {
        const fileName = "巡检报告列表_" + GetDateTime() + ".xlsx";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelSelectVisiable = false;
        }
      });
    },
    excelSureActivation(list) {
      const {
        page: { pageNum, pageSize }
      } = this;
      const params = {
        pageNum,
        pageSize,
        prjId: this.prj.prjId,
        name: this.name,
        startDate: this.statisticalStartDate,
        endDate: this.statisticalEndDate,
        list
      };
      activationService.activationExportPrj(params).then((response) => {
        const fileName = "人员活跃度列表_" + GetDateTime() + ".xlsx";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelSelectVisiable = false;
        }
      });
    },
    selectionInspectionReport(val) {
      this.multipleSelection = val;
    },
    selectionActivation(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang='scss' scoped>
.activation {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: white;
  .content{
    width: 100%;
    height: 100%;
    padding: var(--big-space);
    display: flex;
    flex-direction: column;
    .screenRegion {
      width: 100%;
      padding: var(--big-space) 0;
      display: flex;
      align-items: center;
      span {
        font-family: "Microsoft YaHei UI";
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: var(--key-color);
        white-space: nowrap;
      }
    }
    .tableStyle{
      height: 1px;
      flex-grow: 1;
    }
    .page{
      padding-top: var(--middle-space);
      .el-pagination {
        float: right;
      }
    }
  }
}
.openModify {
  width: 500px;
  padding-bottom: 10px;
}
</style>
